import * as ReactNative from "react-native";

/**
 * Live-Zugriff auf findNodeHandle und BackHandler.
 * Auf Web ruft die Sperre das nicht auf: react-native-web wirft dort.
 */
export const finderHost = {
  findNodeHandle(node: unknown): number | null {
    const handle = ReactNative.findNodeHandle(node as never);
    return typeof handle === "number" ? handle : null;
  },
  setAccessibilityFocus(handle: number) {
    ReactNative.AccessibilityInfo.setAccessibilityFocus(handle);
  },
  addBackHandler(handler: () => boolean) {
    return ReactNative.BackHandler.addEventListener("hardwareBackPress", handler);
  },
};
